import { Card } from "@/components/ui/card";

export function ProductInsights() {
  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Insights</h3>
      <p className="text-sm text-muted-foreground">
        Additional single-product insights go here...
      </p>
    </Card>
  );
}
